@if (canCancel) {
  <div class="cancel-transfer-box">
    <div class="cancel-transfer-action-row">
      <button
        mat-stroked-button
        disableRipple="true"
        class="secondary_materials_button small_button"
        (click)="onCancel()"
        [disabled]="isCanceling">
        @if (isCanceling) {
          <mat-spinner diameter="16" style="display: inline-block; margin-right: 8px"></mat-spinner>
        }
        Cancel Withdrawal
      </button>
    </div>
  </div>
}
